/**
 * 页面异常埋点
 * @return {[type]} [description]
 */

(function(win, undefined) {
  var salog_burriedPoint = {
    $hook: $("#buryError"),
    // 页面异常参数设置
    params: {
      bid: "", // 产品线标识
      error_detail: "", // 报错详情，建议传报错内容英文首字母简称
      error_type: "1", // 错误类型
      error_code: "", // 错误代码
      type_name: "", // 接口名称
      member_id: $.cookie("custno") || "",
      member_level: $.cookie("custLevel") || "",
      region: $.cookie("SN_CITY") || ""
    },
    apiCode: {
      getHome: 1, // 首页接口
      watering: 2, // 浇水接口
      inviteFriend: 3, // 邀请好友获取token
      getCurrentHelp: 4, // 获取弹幕列表
      getHelpHome: 5, // 助力首页
      help: 6, // 助力接口
      getHelpRecord: 7, // 助力记录
      getGoodsList: 8, // 可兑换商品列表
      exchangeGoods: 9 // 兑换接口
    },
    // 错误详情列表
    errorDetail: {},
    // 发送异常埋点信息
    sendErrorMsg: function(apiName, inputArgs, res) {
      if (res && typeof res === "object") {
        if (res.api) {
          let _arrTemp = res.api.split(".");
          if (_arrTemp.length > 1) {
            apiName = _arrTemp[1];
          }
        }

        var self = this;
        var errorCode = "";
        var apiCodeNum =
          typeof self.apiCode[apiName] === "undefined"
            ? "99999"
            : self.apiCode[apiName];
        if (apiCodeNum == "99999") {
          return;
        }

        if (typeof apiName === "undefined") {
          apiName = "无接口名";
        }

        if (typeof inputArgs === "undefined") {
          inputArgs = "无入参";
        }
        if (res.code && res.code == "1") {
          if (res.data && typeof res.data === "object") {
            if (res.data.resultCode) {
              if (res.data.resultCode !== "0000") {
                errorCode = res.data.resultCode;
              } else {
                if (
                  apiName === "getHelpHome" &&
                  res.data.helpStatus &&
                  res.data.helpStatus.resultCode != "0000"
                ) {
                  // 种树助力首页接口业务场景状态码是res.data.helpStatus.resultCode
                  errorCode = res.data.helpStatus.resultCode;
                } else {
                  errorCode = "99999";
                }
              }
            } else {
              errorCode = "99999";
            }
          } else {
            errorCode = "99999";
          }
        } else if (res.code == "10" && res.data && res.data.code) {
          // 领券接口code为10 ，加上res.data.code区分挑战类型、干死等情况
          errorCode = res.code + res.data.code;
        } else if (typeof res === "object" && res.api == "errorApiTiaoZhan") {
          errorCode = JSON.stringify(res);
        } else {
          errorCode = res.code;
        }
        if (errorCode === "99999") {
          return;
        }
        self.params.bid = self.$hook.attr("data-bid");
        inputArgs =
          typeof inputArgs === "object" ? JSON.stringify(inputArgs) : inputArgs;

        let _resdata = typeof res === "object" ? JSON.stringify(res) : res;

        self.params.error_code = "smcp-cultivate-2" + apiCodeNum + errorCode; // 错误代码
        self.params.error_detail = inputArgs + _resdata; // 错误详情
        self.params.type_name = apiName; // 相关接口

        console.log(self.params);
        try {
          sa.openAPI.sendMsgV2(self.params);
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  win.sendErrorMsg = function(apiName, inputArgs, res) {
    try {
      salog_burriedPoint.sendErrorMsg(apiName, inputArgs, res);
    } catch (e) {}
  };
  win.errorDetail = salog_burriedPoint.errorDetail;

  $(function() {
    // 初始化埋点方法
    if (window.sa) {
      try {
        sa.openAPI = sa.openAPI || {};
        sa.initTrackerConfig();
      } catch (e) {}
    }
  });
})(window);
